module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_id_card.2d519e399c677be8d907a635cddc6b5e.png";